import React, { useState, useContext, useEffect } from 'react'
import { CartsAppContext } from '../context/carts-app-context'

const OrderPreferredRecognition = ({ itemId }) => {
  const {
    cart,
    actions: { setCart }
  } = useContext(CartsAppContext)

  const [recognitionText, setRecognitionText] = useState('')
  const [hideRecognitionForm, setHideRecognitionForm] = useState(false)

  useEffect(() => {
    let newCart = {
      ...cart,
      ...(cart.items[membershipItemId]['preferredRecognitionName'] = '')
    }
    setCart(newCart)
  }, [])

  let membershipItemId
  cart.items.filter((item, i) => {
    item.id === itemId && item.type === 'membership_plan'
      ? (membershipItemId = i)
      : null
  })

  const toggleRecognition = ii => {
    let newCart

    if (ii === 0) {
      setRecognitionText('')
      newCart = {
        ...cart,
        ...(cart.items[membershipItemId]['preferredRecognitionName'] = '')
      }
    } else {
      setRecognitionText(null)
      newCart = {
        ...cart,
        ...(cart.items[membershipItemId]['preferredRecognitionName'] = null)
      }
    }
    setCart(newCart)
    setHideRecognitionForm(!hideRecognitionForm)
  }

  const displayRecognitionOptions = toggleRecognition => {
    const recognitionOptions = ['name', 'anonymous']
    const listRecOptions = recognitionOptions.map((option, ii) => {
      return (
        <li
          key={option}
          className="radio"
        >
          <input
            type="radio"
            name={'recognition-boolean' + itemId}
            defaultChecked={ii === 0 ? 'pref-rec-text-option' : null}
            onChange={() => toggleRecognition(ii)}
            id={ii === 0 ? 'pref-rec-text-option' : 'pref-rec-anon-option'}
          />
          <label
            htmlFor={ii === 0 ? 'pref-rec-text-option' : 'pref-rec-anon-option'}
          >
            {ii === 0
              ? ' I would like to be recognized by name.'
              : ' I would like to remain anonymous.'}
          </label>
        </li>
      )
    })

    return (
      <div className="input radio_buttons optional donation_form_recognition_name_input_show field_without_errors">
        <ul>{listRecOptions}</ul>
      </div>
    )
  }

  const handleRecTextChange = target => {
    const { value } = target
    setRecognitionText(value)

    let newCart = {
      ...cart,
      ...(cart.items[membershipItemId]['preferredRecognitionName'] = value)
    }

    setCart(newCart)
  }

  return (
    <div
      id="preferred-recognition-fields"
      className="w-full sm:w-3/4 input"
    >
      <br />
      <p className="cta-label block">Preferred Recognition *</p>
      <span className="block mb-4 text-14 leading-normal font-light">
        We'd love to recognize your generous donation in our Annual Report.
        Please provide the name that you would like for us to use, or let us
        know if you'd prefer to be anonymous.
      </span>
      <div className="flex flex-wrap items-center">
        {displayRecognitionOptions(toggleRecognition)}
        {!hideRecognitionForm && (
          <div className="w-full my-8 string optional donation_form_preferred_recognition_name">
            <input
              type="text"
              id="pref-rec-text-input"
              className="string optional"
              maxLength="70"
              size="70"
              value={recognitionText}
              aria-required={true}
              aria-labelledby="preferred-recognition-fields"
              onChange={({ target }) => handleRecTextChange(target)}
            />
            <span className="text-12">* This field is required</span>
          </div>
        )}
      </div>
      <br />
    </div>
  )
}

export default OrderPreferredRecognition
